import React from "react";
import { Link } from "react-router-dom";
import { Glyphicon } from "react-bootstrap";
import _ from "lodash";

import { formatDateSmall } from "../../../../../utils/dates";
import Table from "../../../../../components/common/table/Table";
import messagesIcon from "../../../../../assets/images/speech-bubble-grey.svg";
import arrowRightIcon from "../../../../../assets/images/arrow-right.svg";

import styles from "./Pitches.scss";

class Pitches extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showRejectedProjects: false
    };

    this.toogleRejectedProjects = this.toogleRejectedProjects.bind(this);
  }

  render() {
    const matches = this.getCurrentPitchedMatches();
    const mappedMatches = matches.map(match => {
      const pitch = _.get(match, "pitch");
      const { project } = match;

      return {
        rowKey: pitch.id,
        disabled: pitch.accepted === false,
        data: [
          {
            displayText: this.getProjectDisplayText(project),
            orderByText: project.title
          },
          {
            displayText: formatDateSmall(pitch.last_activity_at),
            orderByText: pitch.last_activity_at
          },
          {
            displayText: this.getMessagesIcon(pitch, project.id),
            orderByText: pitch.messages.length
          },
          {
            displayText: this.getActions(project.id)
          }
        ]
      };
    });

    const tableData = {
      headers: [
        {
          displayText: "PROJECT"
        },
        {
          displayText: "LAST ACTIVITY"
        },
        {
          displayText: "MESSAGES"
        },
        {
          displayText: "",
          sortDisable: true
        }
      ],
      rows: mappedMatches
    };

    const defaultSort = {
      headerIndex: 1,
      order: "desc"
    };

    return (
      <div className={styles.pitches}>
        <h2 className={styles.pageTitle}>
          Member Pitches
          <span className={styles.filters}>{this.getFilterButtons()}</span>
        </h2>
        <div className={styles.divider}>
          <div className={styles.top} />
          <div className={styles.bottom} />
        </div>

        <Table
          name="AdminPitchesTable"
          colsConfig={["50%", "25%", "20%", "5%"]}
          defaultSort={defaultSort}
          tableData={tableData}
        />
      </div>
    );
  }

  getCurrentPitchedMatches() {
    let pitchedMatches;

    if (this.state.showRejectedProjects) {
      pitchedMatches = this.props.pitchedMatches;
    } else {
      pitchedMatches = _.filter(
        this.props.pitchedMatches,
        pitchedMatch =>
          pitchedMatch &&
          pitchedMatch.pitch &&
          pitchedMatch.pitch.accepted !== false
      );
    }

    return pitchedMatches;
  }

  getProjectDisplayText(project) {
    const company = _.get(project, "employer.profile.company") || {};

    return (
      <div className={styles.rowHeader}>
        <div>
          <Link to={`/admin/company/${company.id}`}>{company.name}</Link>
        </div>

        <div className={styles.rowHeaderSubtitle}>
          <Link to={`/admin/project/${project.id}/detail`}>
            {project.title}
          </Link>
        </div>
      </div>
    );
  }

  getMessagesIcon(pitch, projectId) {
    let messagesCount = _.isEmpty(pitch.messages) ? "0" : pitch.messages.length;

    if (messagesCount < 10) {
      messagesCount = "0" + messagesCount;
    }

    return (
      <div className={styles.actions}>
        <Link
          to={`/admin/project/${projectId}/pitch/${pitch.id}/messages`}
          className={styles.messages}
        >
          <img
            src={messagesIcon}
            alt="Messages"
            className={styles.messagesImage}
          />
          <span className={styles.messagesText}>{messagesCount}</span>
        </Link>
      </div>
    );
  }

  getActions(projectId) {
    return (
      <div className={styles.actionsContainer}>
        <Link to={`/admin/project/${projectId}/detail`}>
          <img src={arrowRightIcon} className={styles.arrowButton} />
        </Link>
      </div>
    );
  }

  getFilterButtons() {
    const toogleRejectedComponent = this.state.showRejectedProjects ? (
      <span>
        {" "}
        <Glyphicon glyph="eye-close" />
        &nbsp; Hide Rejected
      </span>
    ) : (
      <span>
        {" "}
        <Glyphicon glyph="eye-open" />
        &nbsp; Show Rejected
      </span>
    );

    return (
      <span className={styles.filterButtons}>
        <span
          className={styles.filterButtonsItem}
          onClick={this.toogleRejectedProjects}
        >
          {toogleRejectedComponent}
        </span>
      </span>
    );
  }

  toogleRejectedProjects() {
    this.setState(prevState => {
      return {
        showRejectedProjects: !prevState.showRejectedProjects
      };
    });
  }
}

export default Pitches;



// WEBPACK FOOTER //
// ./src/routes/admin/memberApprovedProfile/pitches/components/Pitches.js